import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import CallerStateIsForm from './CallerStateIsForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(CallerStateIsForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/CallerStateIs/CallerStateIsForm.container.js